import { useTranslation } from "@/hooks/useTranslation"
import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"
import {
  useAiPolicyAgentOptions,
  useAiPolicyConditionOptions
} from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies"
import { getAiPoliciesFilters } from "./getAiPoliciesFilters"

// The AI policies list's filter bar, kept in the query string the API is asked
// with
export const FilterAiPoliciesTab = () => {
  const { t } = useTranslation()
  const agents = useAiPolicyAgentOptions()
  const { toolCategories } = useAiPolicyConditionOptions()
  const filters = getAiPoliciesFilters(t, {
    agents: agents.options,
    toolCategories
  })

  return (
    <Filter.Provider isLoading={agents.isLoading}>
      <Filter.Template
        isLoading={agents.isLoading}
        search={
          agents.isLoading ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch id="FilterAiPolicies" filters={filters} />
          )
        }
      />
    </Filter.Provider>
  )
}
